'use client'

import React from 'react'
import { KiaoConfirmProvider } from '@kiao-voice/ui-kit'

/**
 * Client boundary around the ui-kit {@link KiaoConfirmProvider} so the SERVER
 * `(app)` route-group layout can mount it.
 *
 * The ui-kit `dist` modules are authored WITHOUT a `'use client'` directive —
 * they work only because their importers (billing-page, team-page) are client
 * components. The `(app)` layout is a server component, so importing the ui-kit
 * provider there pulls its `useState`/`useEffect` into the server graph and the
 * build fails ("This React Hook only works in a Client Component"). Re-exporting
 * it through this `'use client'` wrapper adds the boundary — mirroring how the
 * server layout already imports the (client) `ConnectedAppShell`.
 *
 * It's the SAME ui-kit module instance / React context, so pages that call
 * `useKiaoConfirm` straight from `@kiao-voice/ui-kit` resolve to this provider.
 */
export function AppConfirmProvider({ children }: { children: React.ReactNode }) {
  return <KiaoConfirmProvider>{children}</KiaoConfirmProvider>
}
